



































import Vue from "vue";
import InfoProject from "@/components/InfoProject.vue";
import CardProject from "@/components/CardProject.vue";
import Footer from "@/components/Footer.vue";

type listProjectModel = {
  length: number;
  [index: number]: {
    imgPath: string;
    imgTotal: number;
    title: string;
    platform: string;
    app: string;
  };
};

type listInfoModel = {
  [index: number]: { icon?: string; text?: string; total?: number };
};

export default Vue.extend({
  name: "Project",
  components: { InfoProject, CardProject, Footer },
  data() {
    return {
      isLoading: true,
      listProject: [] as listProjectModel,
      listInfo: [] as listInfoModel,
    };
  },
  async mounted() {
    await this.loadData();
    this.isLoading = true;
  },
  methods: {
    async loadData() {
      try {
        this.listProject = await fetch("./assets/listProject.json").then(
          (res) => {
            return res.json();
          }
        );

        this.listInfo = await fetch("./assets/listInfo.json").then((res) => {
          return res.json();
        });
        this.listInfo[0].total = this.listProject.length;
      } catch (error) {
        console.log(error);
      }
    },
  },
});
